import React from 'react'
import { useFormContext } from '../../Context/FormContext';

const Step5 = ({}) => {

  const { formResponse } = useFormContext();

  const BASE_URL = process.env.REACT_APP_FRONT_URL;

  return (

    <div>
      <div className="tab-pane verification-wrpr thankyou">
      <div className="main-hding mt-0"><strong>Thank You!</strong></div>   
        <div className="row">
          <div className="col-md-12">
            <p className='text-center'>Your email verified and issue submitted successfully.</p>
            <p className='text-center'>Your reported issue reference with SHIPCONREP is</p>
            <div className="refid"><span>{formResponse?.reference_num}</span></div>
            <p className='text-center'>You will receive an e-mail which contains all the information you submitted.</p>
            <p className='text-center' style={{marginBottom:"7px"}}>Please ensure that this reference number is specified on the subject line on any email you sent to SHIPCONREP</p>
            <p className='text-center' style={{marginBottom:"7px"}}>related to this issue</p>
            <p className='text-center'><a href="#">info@shipconrep.com</a></p>
          </div>
        </div>
        <div className="row">

          <div className='col-md-12'>

            <div className="d-grid gap-2 mt-4 mb-4">
              <a href={BASE_URL} className="btn btn-primary btn-informant !flex items-center justify-center">Go Home <i className="icon-check"></i></a>
            </div>

          </div>

        </div>
      </div>
    </div>

  )
}

export default Step5